import React from "react";
import { useLocation, useNavigate } from "react-router";
import { FaMoon, FaSun } from "react-icons/fa6";
import { useTranslation } from "react-i18next";

import { IconButton } from "../../index";
import { useTheme } from "../../../hooks/useTheme";
import { MPLogoPrimary, MPLogoWhite } from "../../../assets";

const PoppableHeader: React.FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();

  const title = () => {
    const cleanPathname = pathname.split("/")[1];
    return t(`${cleanPathname}.title`);
  };

  return (
    <header className="flex-between p-4 bg-card text-card-foreground sticky top-0">
      <img src={theme === "dark" ? MPLogoWhite : MPLogoPrimary} className="w-12" onClick={() => navigate("/")} />
      <div className="text-xl font-medium">{title()}</div>
      <IconButton
        icon={theme === "dark" ? FaSun : FaMoon}
        size="lg"
        variant={{ bg: "background", text: "foreground" }}
        onClick={toggleTheme}
      />
    </header>
  );
};

export default PoppableHeader;
